import React, { useState } from 'react';
import { FAQ_GROUPS } from './resourcesData';

const Chevron = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

const FaqGroup = ({ group, groupIndex }) => {
    const [open, setOpen] = useState(groupIndex === 0);
    const [openQ, setOpenQ] = useState(0);

    return (
        <div className="lp-faq-group">
            <button className="lp-faq-group-btn" onClick={() => setOpen(o => !o)}>
                {group.title}
                <i className={open ? 'is-open' : ''}><Chevron /></i>
            </button>
            {open && (
                <div className="lp-faq-group-body">
                    {group.items.map((item, i) => (
                        <div className="lp-faq-item" key={i}>
                            <button className="lp-faq-q" onClick={() => setOpenQ(q => q === i ? -1 : i)}>
                                {item.q}
                                <i className={openQ === i ? 'is-open' : ''}><Chevron /></i>
                            </button>
                            {openQ === i && <div className="lp-faq-a">{item.a}</div>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const ResourcesFaqSection = () => (
    <section className="lp-faq-sec">
        <div className="lp-faq-inner">
            <div className="lp-faq-head">
                <div className="lp-pe-eyebrow" data-lp-reveal>FAQs</div>
                <h2 className="lp-h2" style={{ margin: '0 auto 10px', maxWidth: 'none' }} data-lp-reveal>Common questions — answered.</h2>
                <p className="lp-sub" style={{ margin: '0 auto' }} data-lp-reveal data-lp-delay="60">Last updated June 2026.</p>
            </div>

            {FAQ_GROUPS.map((group, i) => <FaqGroup group={group} groupIndex={i} key={group.title} />)}
        </div>
    </section>
);

export default ResourcesFaqSection;
